export default __webpack_public_path__ + "static/media/tab_quiz_active.a6755574.svg";